import api from '~/services/api';
import { toast } from 'react-toastify';
import { CreatePDFProps, ParamGeneratePdfDataProps } from '../../protocols/PdfProps';

export async function generatePdfData(
  params: ParamGeneratePdfDataProps,
): Promise<CreatePDFProps> {
  try {
    const { data } = await api.post(`/conferencia-tesouraria/pdfReport`, {
      ...params,
    });
    return data;
  } catch (error: any) {
    toast.warning(error.message);
    return error;
  }
}
